// extracted by mini-css-extract-plugin
module.exports = {"root":"EditProjectListingNamePanel_root__VmhOK","form":"EditProjectListingNamePanel_form__1xwjT","title":"EditProjectListingNamePanel_title__3Ckay"};